import { EditableLocation } from "../types/EditableLocation";
import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "LOCATION/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "LOCATION/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "LOCATION/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "LOCATION/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "LOCATION/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "LOCATION/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableLocation, {}, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
